<template>
<v-card >
  <v-card-title class='title' >
    <v-tooltip bottom>
      <template v-slot:activator="{ on }" >
        <v-btn class='hidden-xs-only' icon
          :loading='downloading || getClientsRequest.loading'
          @click='download' v-on='on' >
          <v-icon >cloud_download</v-icon>
        </v-btn>
      </template>
      <span>Download your client list as a csv file</span>
    </v-tooltip>
    Clients
    <v-spacer></v-spacer>
    <v-btn flat to='/clients/merge' >
      <v-icon >merge_type</v-icon>
      Merge clients
    </v-btn>
    <v-btn
      @click="openGlobalDialog(true, 'CreateClient')"
      color='primary'
      outline outlined >
      <v-icon >add</v-icon> New client
    </v-btn>
    <!-- <v-btn
      :href="https://api.appointmentguru.co/api/v3/practitioner/practitioners/export_customers/?practitioner=11156"
      target='_blank' icon >
      <v-icon>cloud_download</v-icon>
    </v-btn> -->
  </v-card-title>
  <v-card-text>
    <vuex-loader :request-id='requests.appointmentInRange' ></vuex-loader>
    <v-divider></v-divider>
    <v-layout class='hidden-xs-only' >
      <v-flex xs12 sm9 >
        You saw these
        <v-chip label class="green white--text">
          <v-icon left>person</v-icon> {{clientsInRange.length}} clients
        </v-chip>
        from
        <v-chip label @click='$store.dispatch("ACTIVATE_RANGE_PICKER")' >
          <v-icon left >event</v-icon> {{globalActiveDateRangeFormatted}}
        </v-chip>
      </v-flex>
      <v-flex class='text-xs-right' xs12 sm3 >
        <birthday-bar ></birthday-bar>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout row wrap>
      <v-flex xs12 md6 lg6 xl4 v-for='clientId in visibleClients' :key='clientId' >
        <v-list dense>
          <!-- @listitem:goclicked='$router.push({path: "/clients/" + clientId})' -->
          <client-list-item
            v-if='getClientById(clientId) && getClientById(clientId).id'
            :client='getClientById(clientId)'
            :relationship-id='getClientById(clientId).id'
            @listitem:clicked="gotoClient(clientId)"
            :with-details='false' >
              <v-list-tile-sub-title slot='subtitle' >
                {{appointmentsByClient[clientId].length}} appointment<span v-if='appointmentsByClient[clientId].length > 1'>s</span>.
                Due: {{formatCurrency(appointmentsByClient[clientId][0].currency, appointmentsByClient[clientId].totalOwed) }}.
                Paid: {{formatCurrency(appointmentsByClient[clientId][0].currency, appointmentsByClient[clientId].totalPaid) }}
              </v-list-tile-sub-title>
            <!-- <client-action-menu slot='avatar' ></client-action-menu> -->
          </client-list-item>
          <v-list-tile v-else >
            <v-list-tile-action >
              <v-progress-circular width='2' indeterminate color='amber' >
              </v-progress-circular>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>loading ..</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider ></v-divider>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout >
      <v-flex xs12 >
      <span class='pt-2'>Showing {{displayLimit}} of {{clientsInRange.length}}</span>
      <v-btn small flat text @click='displayLimit += displayLimit' >Load more</v-btn>
      </v-flex>
    </v-layout>
  </v-card-text>
</v-card>
</template>

<script>
import axios from 'axios'
import ClientListItem from '@/components/client/ClientListItem'
import ClientActionMenu from '@/components/client/ClientActionMenu'
import BirthdayBar from '@/components/lists/BirthdayBar'

import {
  LIST_APPOINTMENTS_IN_RANGE_REQ,
  LIST_CLIENTS_REQ
} from '@/store/constants'

export default {
  name: 'ClientHome',
  components: {ClientListItem, ClientActionMenu, BirthdayBar},
  data () {
    return {
      displayLimit: 20,
      appointmentsByClient: {},
      requests: {
        appointmentInRange: LIST_APPOINTMENTS_IN_RANGE_REQ
      },
      downloading: false
    }
  },
  mounted () {
    this.getActiveClients()
  },
  methods: {
    addPriceDetails (li, appt) {
      if (appt.price) {
        let price = parseFloat(appt.price)
        if (appt.status === 'P') {
          li.totalPaid += price
        } else {
          li.totalOwed += price
        }
      }
    },
    download () {
      this.downloading = true
      let path = '/api/v3/practitioner/practitioners/export_clients/'
      let base = this.$appointmentguru.baseUrl
      let headers = this.$appointmentguru.headers
      let url = `${base}${path}`
      axios({
        url,
        headers,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        this.downloading = false
        link.href = url
        link.setAttribute('download', 'client-list.csv')
        document.body.appendChild(link)
        link.click()
      }).catch(() => {
        window.alert('There was a problem tying to create your download')
        this.downloading = false
      })
    },
    gotoClient (clientId) {
      let rel = this.getRelationByClientId(clientId)
      let path = '/clients/' + clientId
      if (rel && rel.id) {
        path = '/clients/r/' + rel.id
      }
      this.$router.push(path)
    }
  },
  computed: {
    visibleClients () {
      return this.clientsInRange.slice(0, this.displayLimit)
    },
    clientsInRange () {
      let clients = []
      let vm = this
      vm.appointmentsByClient = {}

      this.appointments
        .map(function (appt) {
          if (clients.indexOf(appt.client) === -1) {
            clients.push(appt.client)
          }
          try {
            vm.appointmentsByClient[appt.client].push(appt)
            vm.addPriceDetails(vm.appointmentsByClient[appt.client], appt)
          } catch (e) {
            vm.appointmentsByClient[appt.client] = []
            vm.appointmentsByClient[appt.client].push(appt)
            vm.appointmentsByClient[appt.client].totalOwed = 0
            vm.appointmentsByClient[appt.client].totalPaid = 0
            vm.addPriceDetails(vm.appointmentsByClient[appt.client], appt)
          }
        })
      return clients
    },
    getClientsRequest () {
      return this.$store.getters.getRequestById(LIST_CLIENTS_REQ, true)
    },
    appointments () {
      return this.$store.getters.activeAppointments
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientHome.vue?36be4a35